__webpack_require__.p = "/reports-details-new-format/referrals-hub/";